import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { TooltipProvider } from '@client/components/ui/tooltip';
import { ToastProvider } from '@client/components/ui/toast';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <TooltipProvider>
      <ToastProvider>
        <Outlet />
      </ToastProvider>
    </TooltipProvider>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-md px-5 py-24 text-center">
      <h1 className="page-title">404</h1>
      <p className="mt-2 text-muted">This page does not exist.</p>
      <a href="/" className="mt-4 inline-block text-brand">Back to the Investor Room</a>
    </div>
  ),
});
